exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:200,400,500,600,700);", ""]);

// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47e36b24","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./web/webroot/_ui/responsive/common/js/src/components/productrefinement/productrefinement.scss
// module id = 810
// module chunks = 38